import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, number, object, string } from "yup";
import { CancelAdvancePaymentFormValue } from "src/models/AdvancePayment.model";
import {
  useCencelAdvancePaymentByIdMutation,
  useGetAdvancePaymentByIdQuery,
} from "src/services/AdvancePaymentService";
import { showToast } from "src/utils/showToaster";
import useDrawer from "src/hooks/useDrawer";
import CancelAdvancePayment from "../Layouts/CancelAdvancePayment";

type Props = {
  onClose: () => void;
  selectedAdvancePaymentId: string;
};

const CancelAdvancePaymentWrapper = ({ onClose, selectedAdvancePaymentId }: Props) => {
  const { drawer} = useDrawer();
  const { data } = useGetAdvancePaymentByIdQuery(selectedAdvancePaymentId);

  const physicalModes =
    drawer?.filter((mode: any) => mode?.type === "PHYSICAL") || [];

  const initialValues: CancelAdvancePaymentFormValue = {
    cancelReason: "",
    paymentMode: [
      ...physicalModes.map((mode: any) => ({
        name: mode.name,
        value: mode.value,
        quantity: "",
        type: mode.type,
        availableQuantity: mode.quantity,
      })),
    ],
  };

  const validationSchema = object().shape({
    cancelReason: string().required("Please enter cancel reason"),
    paymentMode: array().of(
      object().shape({
        name: string().required(),
        value: number().required(),
      })
    ),
  });

  const [cancelAdvancePayment] = useCencelAdvancePaymentByIdMutation();

  const handleSubmit = (
    values: CancelAdvancePaymentFormValue,
    { setSubmitting, resetForm }: FormikHelpers<CancelAdvancePaymentFormValue>
  ) => {
    const cancelAmount = data?.data.amount || 0;

    const totalAmount = values.paymentMode.reduce((acc, item) => {
      const qty = Number(item.quantity || 0);
      return acc + qty * (item.value || 0);
    }, 0);

    if (totalAmount !== cancelAmount) {
      showToast("error", "Advance amount and Cancel amount must be equal.");
      return setSubmitting(false);
    }

    const payload = {
      cancelReason: values.cancelReason,
      paymentMode: values.paymentMode
        .filter((item) => item.quantity && Number(item.quantity) > 0)
        .map((item) => ({
          name: item.name,
          value: item.value,
          quantity: Number(item.quantity),
          type: item.type,
        })),
    };

    cancelAdvancePayment({
      id: selectedAdvancePaymentId,
      body: payload,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else if (res?.data?.status) {
        showToast("success", res?.data?.message);
        resetForm();
        onClose();
      } else {
        showToast("error", res?.data?.message);
      }
      setSubmitting(false);
    });
  };

  

  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            <CancelAdvancePayment
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default CancelAdvancePaymentWrapper;
